import { HTTP } from '@/api/http-common'

export default {
  getProperties (callback, param) {
    HTTP.get(param.token + '/properties').then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  },
  getCurrency (callback, param) {
    HTTP.get(param.token + '/currency').then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  },
  getFeatures (callback, param) {
    HTTP.get(param.token + '/features').then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  },
  getPointSpotApp(callback, param) {
    HTTP.get(param.token + '/pointspot?web_name=' + param.webName).then(response => {
      callback(response)
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/properties/index.js